
import styled, { css } from 'styled-components';

const AlphaLogoSVG = () => css`
    height:24px;
    width:106px;
`;


export default styled.svg([AlphaLogoSVG]);